"use strict";

exports.__esModule = true;
exports.default = void 0;
var _default = exports.default = {
  el: {
    colorpicker: {
      confirm: 'Confirmar',
      clear: 'Limpiar'
    },
    datepicker: {
      now: 'Ahora',
      today: 'Hoy',
      cancel: 'Cancelar',
      clear: 'Cancelar',
      confirm: 'Confirmar',
      selectDate: 'Seleccionar fecha',
      selectTime: 'Seleccionar hora',
      startDate: 'Fecha Incial',
      startTime: 'Hora Inicial',
      endDate: 'Fecha Final',
      endTime: 'Hora Final',
      prevYear: 'Año Anterior',
      nextYear: 'Próximo Año',
      prevMonth: 'Mes Anterior',
      nextMonth: 'Próximo Mes',
      year: '',
      month1: 'enero',
      month2: 'febrero',
      month3: 'marzo',
      month4: 'abril',
      month5: 'mayo',
      month6: 'junio',
      month7: 'julio',
      month8: 'agosto',
      month9: 'septiembre',
      month10: 'octubre',
      month11: 'noviembre',
      month12: 'diciembre',
      // week: 'semana',
      weeks: {
        sun: 'dom',
        mon: 'lun',
        tue: 'mar',
        wed: 'mié',
        thu: 'jue',
        fri: 'vie',
        sat: 'sáb'
      },
      months: {
        jan: 'ene',
        feb: 'feb',
        mar: 'mar',
        apr: 'abr',
        may: 'may',
        jun: 'jun',
        jul: 'jul',
        aug: 'ago',
        sep: 'sep',
        oct: 'oct',
        nov: 'nov',
        dec: 'dic'
      }
    },
    select: {
      loading: 'Cargando',
      noMatch: 'No hay datos que coincidan',
      noData: 'Sin datos',
      placeholder: 'Seleccionar'
    },
    cascader: {
      noMatch: 'No hay datos que coincidan',
      loading: 'Cargando',
      placeholder: 'Seleccionar'
    },
    pagination: {
      goto: 'Ir a',
      pagePosition: ' / {name} pag. ',
      pagesize: 'Items por pág.',
      total: 'Total: {total}',
      pageClassifier: '',
      of: 'de'
    },
    messagebox: {
      confirm: 'Aceptar',
      cancel: 'Cancelar',
      error: 'Entrada inválida'
    },
    upload: {
      deleteTip: 'press delete to remove',
      // to be translated
      delete: 'Eliminar',
      preview: 'Vista Previa',
      continue: 'Continuar'
    },
    table: {
      emptyText: 'Sin datos',
      confirmFilter: 'Confirmar',
      resetFilter: 'Reiniciar',
      clearFilter: 'Limpiar',
      sumText: 'Suma'
    },
    tree: {
      emptyText: 'Sin datos'
    },
    transfer: {
      noMatch: 'No hay datos que coincidan',
      noData: 'Sin datos',
      titles: ['Lista 1', 'Lista 2'],
      filterPlaceholder: 'Ingresar palabra clave',
      noCheckedFormat: '{total} artículos',
      hasCheckedFormat: '{checked}/{total} revisados',
      search: 'Buscar'
    },
    gantt: {
      placeholder: 'Buscar',
      hour: 'Hora',
      day: 'Día',
      week: 'Semana',
      month: 'Mes',
      quarter: 'Cuatrimestre',
      year: 'Año',
      collapse: 'Colapsar todo',
      expand: 'Expandir todo',
      export: 'Exportar',
      resources: 'Recursos',
      criticalPath: 'Camino crítico',
      autoScheduling: 'Auto Scheduling',
      fullscreen: 'Pantalla completa',
      newTask: 'Nueva tarea',
      task: 'Tarea',
      startDate: 'Comienzo',
      endDate: 'Fin',
      duration: 'Duración',
      columns: 'Columnas',
      taskName: 'Nombre de la tarea',
      days: 'días',
      pickDay: 'Elige día y hora',
      cancel: 'Cancelar',
      confirm: 'Confirmar',
      delete: 'Eliminar',
      today: 'Hoy'
    },
    rate: {
      veryBad: 'Muy mal',
      bad: 'Mal',
      regular: 'Regular',
      veryGood: 'Muy bien',
      good: 'Bien'
    },
    dataviz: {
      emptyTitle: 'Ups...',
      emptyDescription: 'Ha ocurrido un error al cargar la información.',
      emptyButton: 'Recargar'
    },
    formItem: {
      error: 'Error'
    }
  }
};